import AxiosConfig from '../utils/AxiosConfig';

class CoreAccountService {
  async changePassword(currentPassword, newPassword) {
    const response = await AxiosConfig.post('/session/core/changePassword', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data.data;
  }
}

export default new CoreAccountService();
